/* Obtino collection filtering.
 * One form drives filters + sort. Changes are fetched with Shopify's Section Rendering API
 * and swapped into the page; the URL is kept in sync so filtered views are shareable and Back works.
 */
(function () {
  'use strict';
  if (window.__obtColLoaded) return;
  window.__obtColLoaded = true;

  var mqDesktop = window.matchMedia('(min-width: 990px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function Col(root) {
    this.root = root;
    this.id = root.dataset.sectionId;
    this.ac = new AbortController();
    this.req = null;
    this.bind();
  }

  Col.prototype.on = function (el, t, fn, o) { if (el) el.addEventListener(t, fn, Object.assign({ signal: this.ac.signal }, o || {})); };
  Col.prototype.q = function (s) { return this.root.querySelector(s); };

  Col.prototype.bind = function () {
    var self = this;
    this.drawer = this.q('[data-obt-col-drawer]');
    this.form = this.q('[data-obt-col-form]');

    this.on(this.q('[data-obt-col-open]'), 'click', function () { self.openDrawer(); });
    this.root.querySelectorAll('[data-obt-col-close]').forEach(function (b) { self.on(b, 'click', function () { self.closeDrawer(); }); });
    this.on(this.drawer, 'click', function (e) { if (e.target === self.drawer) self.closeDrawer(); });
    this.on(this.drawer, 'close', function () { self.afterClose(); });

    var timer;
    this.on(this.root, 'change', function (e) {
      var t = e.target;
      if (t.matches('[data-obt-col-price]')) return; // handled on commit below
      if (t.matches('input[type=checkbox], [data-obt-col-sort]')) {
        clearTimeout(timer);
        timer = setTimeout(function () { self.apply(); }, 120);
      }
    });
    this.on(this.root, 'change', function (e) { if (e.target.matches('[data-obt-col-price]')) self.apply(); });
    this.on(this.root, 'keydown', function (e) { if (e.key === 'Enter' && e.target.matches('[data-obt-col-price]')) { e.preventDefault(); self.apply(); } });
    this.on(this.form, 'submit', function (e) { e.preventDefault(); self.apply(); });

    this.on(this.root, 'click', function (e) {
      var a = e.target.closest('a[data-obt-col-link]');
      if (a) {
        e.preventDefault();
        if (a.classList.contains('obt-chip--clear')) { self.fams.clear(); self.syncFamInput(); }
        self.load(a.href, true); return;
      }
      var more = e.target.closest('a[data-obt-col-next]');
      if (more) { e.preventDefault(); self.loadMore(more); }
    });

    this.on(window, 'popstate', function () { self.readFamsFromUrl(); self.load(location.href, false); });

    // colour families (theme-side filter on top of Shopify's native filters)
    this.famInput = this.q('[data-obt-fam-input]');
    this.readFamsFromUrl();
    this.on(this.root, 'click', function (e) {
      var b = e.target.closest('[data-obt-fam]');
      if (!b) return;
      var f = b.dataset.obtFam;
      if (self.fams.has(f)) self.fams.delete(f); else self.fams.add(f);
      self.syncFamInput();
      history.pushState({ obtCol: true }, '', self.cleanUrl(self.urlFromForm()));
      self.applyColour();
    });
    this.serverCount = (this.q('[data-obt-col-count]') || {}).textContent;
    this.serverDone = (this.q('[data-obt-col-donecount]') || {}).textContent;
    this.applyColour();
    this.on(mqDesktop, 'change', function () { if (mqDesktop.matches && self.drawer.open) self.drawer.close(); });
  };

  Col.prototype.readFamsFromUrl = function () {
    var v = new URLSearchParams(location.search).get('farge') || '';
    this.fams = new Set(v.split(',').filter(Boolean));
    this.syncFamInput();
  };
  Col.prototype.syncFamInput = function () {
    if (this.famInput) this.famInput.value = Array.from(this.fams).join(',');
  };
  Col.prototype.cleanUrl = function (url) {
    var u = new URL(url, location.origin); u.searchParams.delete('section_id'); u.searchParams.delete('page');
    return u.pathname + u.search;
  };
  Col.prototype.items = function () { return Array.prototype.slice.call(this.root.querySelectorAll('[data-obt-col-grid] > li')); };
  Col.prototype.famOf = function (li) { var c = li.querySelector('[data-obt-family]'); return c ? c.dataset.obtFamily : ''; };

  // fetch every remaining page once so the colour filter covers the whole collection
  Col.prototype.loadAll = function () {
    var self = this;
    var step = function () {
      var next = self.q('[data-obt-col-next]');
      if (!next) return Promise.resolve();
      var u = new URL(next.href, location.origin); u.searchParams.set('section_id', self.id);
      return fetch(u.toString(), { headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = self.q('[data-obt-col-grid]');
        doc.querySelectorAll('[data-obt-col-grid] > li').forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
        var more = doc.querySelector('[data-obt-col-more]'), cur = self.q('[data-obt-col-more]');
        if (more && cur) cur.innerHTML = more.innerHTML;
        return step();
      });
    };
    return step();
  };

  Col.prototype.updateFamCounts = function () {
    var self = this, all = !this.q('[data-obt-col-next]');
    var counts = {};
    this.items().forEach(function (li) { var f = self.famOf(li); if (f) counts[f] = (counts[f] || 0) + 1; });
    this.root.querySelectorAll('[data-obt-fam]').forEach(function (b) {
      var f = b.dataset.obtFam, n = counts[f] || 0, on = self.fams.has(f);
      b.setAttribute('aria-pressed', String(on));
      var c = b.querySelector('[data-obt-fam-count]');
      if (c) c.textContent = all ? String(n) : '';
      var empty = all && n === 0 && !on;
      b.disabled = empty;
      b.hidden = empty;
    });
    var act = this.q('[data-obt-fam-active]');
    if (act) act.textContent = this.fams.size ? '(' + this.fams.size + ')' : '';
  };

  Col.prototype.applyColour = function () {
    var self = this;
    var run = function () {
      var items = self.items(), shown = 0;
      items.forEach(function (li) {
        var ok = !self.fams.size || self.fams.has(self.famOf(li));
        li.hidden = !ok; if (ok) shown++;
      });
      var countEl = self.q('[data-obt-col-count]'), done = self.q('[data-obt-col-donecount]');
      var more = self.q('[data-obt-col-more]');
      var emptyEl = self.q('[data-obt-fam-empty]');
      if (self.fams.size) {
        var label = shown + (shown === 1 ? ' produkt' : ' produkter');
        if (countEl) countEl.textContent = label;
        if (done) done.textContent = label;
        if (more) more.hidden = true;
        if (!emptyEl && shown === 0) {
          emptyEl = document.createElement('div');
          emptyEl.className = 'obt-col__empty'; emptyEl.setAttribute('data-obt-fam-empty', '');
          emptyEl.innerHTML = '<p class="obt-col__emptyh">Ingen produkter i denne fargen.</p><p>Velg en annen farge, eller fjern fargefilteret.</p>';
          var res = self.q('[data-obt-col-results]'); if (res) res.appendChild(emptyEl);
        }
        if (emptyEl) emptyEl.hidden = shown !== 0;
      } else {
        if (countEl && self.serverCount) countEl.textContent = self.serverCount;
        if (done && self.serverDone) done.textContent = self.serverDone;
        if (more) more.hidden = false;
        if (emptyEl) emptyEl.hidden = true;
      }
      self.updateFamCounts();
    };
    if (this.fams.size && this.q('[data-obt-col-next]')) {
      this.root.classList.add('is-loading');
      return this.loadAll().then(run).finally(function () { self.root.classList.remove('is-loading'); });
    }
    run();
    return Promise.resolve();
  };

  Col.prototype.openDrawer = function () {
    if (mqDesktop.matches) {
      // desktop: sidebar is always visible; move focus into it
      var first = this.drawer.querySelector('summary, input');
      if (first) first.focus();
      return;
    }
    this.scrollY = window.scrollY;
    this.drawer.appendChild(this.q('[data-obt-col-panel]'));
    document.documentElement.classList.add('obt-dialog-open');
    this.drawer.showModal();
    var first = this.drawer.querySelector('summary');
    if (first) first.focus();
  };
  Col.prototype.closeDrawer = function () { if (this.drawer.open) this.drawer.close(); };
  Col.prototype.afterClose = function () {
    var panel = this.drawer.querySelector('[data-obt-col-panel]');
    if (panel) this.q('[data-obt-col-home]').appendChild(panel);
    document.documentElement.classList.remove('obt-dialog-open');
    var btn = this.q('[data-obt-col-open]');
    if (btn) btn.focus({ preventScroll: true });
    // bring the customer to the top of the results they just filtered
    var grid = this.q('[data-obt-col-results]');
    if (grid && grid.getBoundingClientRect().top < 0) grid.scrollIntoView({ block: 'start', behavior: reduce.matches ? 'auto' : 'smooth' });
  };

  Col.prototype.urlFromForm = function () {
    var fd = new FormData(this.form);
    var sort = this.root.querySelector('[data-obt-col-sort]');
    if (sort) fd.set('sort_by', sort.value);
    var params = new URLSearchParams();
    fd.forEach(function (v, k) { if (String(v).trim() !== '') params.append(k, v); });
    var base = this.form.getAttribute('action');
    var qs = params.toString();
    return base + (qs ? '?' + qs : '');
  };

  Col.prototype.apply = function () { this.load(this.urlFromForm(), true); };

  Col.prototype.fetchSection = function (url) {
    if (this.req) this.req.abort();
    this.req = new AbortController();
    var u = new URL(url, location.origin);
    u.searchParams.set('section_id', this.id);
    return fetch(u.toString(), { signal: this.req.signal, headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
  };

  Col.prototype.load = function (url, push) {
    var self = this;
    this.root.classList.add('is-loading');
    this.root.setAttribute('aria-busy', 'true');
    // remember which groups are open and where focus was
    var open = {};
    this.root.querySelectorAll('[data-obt-col-group]').forEach(function (d) { open[d.dataset.obtColGroup] = d.open; });
    var focusName = document.activeElement && this.root.contains(document.activeElement) ? (document.activeElement.name + '|' + document.activeElement.value) : null;

    this.fetchSection(url).then(function (doc) {
      ['[data-obt-col-results]', '[data-obt-col-filterbody]', '[data-obt-col-count]', '[data-obt-col-activecount]', '[data-obt-col-donecount]'].forEach(function (sel) {
        var next = doc.querySelector(sel), cur = self.q(sel);
        if (next && cur) {
          cur.innerHTML = next.innerHTML;
          if (next.hasAttribute('hidden')) cur.setAttribute('hidden', ''); else cur.removeAttribute('hidden');
        }
      });
      var nextSort = doc.querySelector('[data-obt-col-sort]'), curSort = self.q('[data-obt-col-sort]');
      if (nextSort && curSort) curSort.value = nextSort.value;
      self.root.querySelectorAll('[data-obt-col-group]').forEach(function (d) {
        if (Object.prototype.hasOwnProperty.call(open, d.dataset.obtColGroup)) d.open = open[d.dataset.obtColGroup];
      });
      if (focusName) {
        var parts = focusName.split('|');
        var el = Array.prototype.find.call(self.root.querySelectorAll('input, select'), function (i) { return i.name === parts[0] && (i.type !== 'checkbox' || i.value === parts[1]); });
        if (el) el.focus({ preventScroll: true });
      }
      if (push) history.pushState({ obtCol: true }, '', self.cleanUrl(url));
      var countEl = self.q('[data-obt-col-count]'); self.serverCount = countEl ? countEl.textContent : '';
      var doneEl = self.q('[data-obt-col-donecount]'); self.serverDone = doneEl ? doneEl.textContent : '';
      self.applyColour();
    }).catch(function (e) {
      if (e && e.name === 'AbortError') return;
      window.location.href = url; // fall back to a normal page load
    }).finally(function () {
      self.root.classList.remove('is-loading');
      self.root.removeAttribute('aria-busy');
    });
  };

  Col.prototype.loadMore = function (link) {
    var self = this;
    link.setAttribute('aria-busy', 'true');
    link.classList.add('is-loading');
    this.fetchSection(link.href).then(function (doc) {
      var grid = self.q('[data-obt-col-grid]');
      var items = doc.querySelectorAll('[data-obt-col-grid] > li');
      var firstNew = null;
      items.forEach(function (li) { var n = document.importNode(li, true); if (!firstNew) firstNew = n; grid.appendChild(n); });
      var more = doc.querySelector('[data-obt-col-more]'), cur = self.q('[data-obt-col-more]');
      if (more && cur) cur.innerHTML = more.innerHTML;
      self.updateFamCounts();
      var a = firstNew && firstNew.querySelector('.obt-card__title a');
      if (a) a.focus({ preventScroll: true });
    }).catch(function () { window.location.href = link.href; });
  };

  Col.prototype.destroy = function () { this.ac.abort(); if (this.req) this.req.abort(); };

  var inst = new Map();
  function boot(scope) {
    (scope || document).querySelectorAll('[data-obt-col]').forEach(function (el) { if (!inst.has(el)) inst.set(el, new Col(el)); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    inst.forEach(function (c, el) { if (e.target.contains(el)) { c.destroy(); inst.delete(el); } });
  });
})();
